import {
  BoxFormStyled,
  ErrorMsgsStyled,
  LabelStyled,
  SubmitButtonStyled,
} from '@Usician/styles/Form.styled';
import { Heading1Styled } from '@Usician/styles/Text.styled';

import React, { useState } from 'react';

import Form from '@hangar31/rc-form';

import { withAuth } from '@Usician/withGraph';
import { withClient } from '@Usician/withGraph';
type FormData = { email: string };
function Forgot({ client }: ForgotPageProps) {
  const [success, setSuccess] = useState(false);
  const onSubmit = async (data: FormData) => {
    await client.forgotPassword(data);
  };
  const onSuccess = () => {
    setSuccess(true);
  };
  return (
    <BoxFormStyled>
      <Form
        onSubmit={onSubmit}
        onSuccess={onSuccess}
        defaultData={{} as FormData}
      >
        <Heading1Styled>Password Recovery</Heading1Styled>
        <div css={{ margin: '0 auto', maxWidth: '45rem', padding: '2rem' }}>
          <LabelStyled>
            <span>Email</span>
            <input required type="email" name="email" />
          </LabelStyled>
        </div>
        {success && (
          <p css={{ marginTop: '4rem', textAlign: 'center' }}>
            <strong>Success!</strong>
            {` A recovery link has been sent to your
                email. Please click on the link to set a new password.`}
          </p>
        )}
        <ErrorMsgsStyled />
        <SubmitButtonStyled
          lg
          stateCSS={{
            WAITING: {},
          }}
        >
          Next &raquo;
        </SubmitButtonStyled>
      </Form>
    </BoxFormStyled>
  );
}

export type ForgotPageProps = ServerSidePagePropsWithClient<
  typeof getServerSideProps
>;
export const getServerSideProps = withAuth(async () => {
  return {
    props: { layout: 'PUBLIC' },
  };
}, 'PUBLIC');
export default withClient(Forgot);
